/*
 * @Author: Tahiti
 * @Date: 2025-12-18
 * @Description: 特效相关翻译（视频特效、图片特效详情页）
 * @FilePath: /weryai-web/locales/modules/effects.ts
 */
export default {
    zh: {
        // 通用
        videoEffectsTitle: '视频特效',
        photoEffectsTitle: '图片特效',
        aiPhotoEffectsTitle: 'AI 图片特效和滤镜',
        aiVideoEffectsTitle: 'AI 娱乐视频特效',
        change: '改变',
        selectVideoEffect: '选择一个视频特效',
        selectImageEffect: '选择一个图片特效',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI 视频特效生成器',
        seoPhotoEffectGenerator: 'AI 图片特效生成器',
        seoVideoEffectDesc: '使用 AI 创建 {title} 视频。上传您的照片，几秒钟内生成爆款视频。',
        seoPhotoEffectDesc: '使用 {title} AI 特效转换您的照片。上传并立即创建令人惊叹的图像。',
        seoVideoKeywords: 'AI视频特效, AI视频生成器, 爆款视频制作, 视频特效在线, 免费AI视频',
        seoPhotoKeywords: 'AI图片特效, AI图片生成器, 在线图片滤镜, 图片特效制作, 免费AI图片',
        
        // 上传相关
        sampleImages: '试用样本图像',
        trySampleImages: '试用样本图像',
        selectType: '选择类型',
        uploadImage: '上传图片',
        pleaseUploadImage: '请上传图片',
        pleaseCompletePromptVariables: '请填写所有提示词变量',
        taskSubmitted: '任务提交成功',
        templateConfigNotFound: '模板配置未找到',
        
        // 类型选择
        useThisTemplate: '使用此模板',
        viewAll: '查看所有',
        viewAllVideoEffects: '查看全部',
        viewAllPhotoEffects: '查看全部',
        
        // 分类名称
        christmasSpecial: '圣诞特惠',
        tiktokTrend: 'TikTok 趋势',
        dance: '跳舞',
        newYear: '新年',
        viral: '热门',
        art: '艺术',
        interactive: '互动',
        trending: '热门',
        portrait: '肖像',
        artistic: '艺术',
        filter: '滤镜',
    },
    en: {
        videoEffectsTitle: 'Video Effects',
        photoEffectsTitle: 'Photo Effects',
        aiPhotoEffectsTitle: 'AI Photo Effects & Filters',
        aiVideoEffectsTitle: 'AI Fun Video Effects',
        change: 'Change',
        selectVideoEffect: 'Select a video effect',
        selectImageEffect: 'Select an image effect',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI Video Effect Generator',
        seoPhotoEffectGenerator: 'AI Photo Effect Generator',
        seoVideoEffectDesc: 'Create {title} video with AI. Upload your photo and generate viral videos in seconds.',
        seoPhotoEffectDesc: 'Transform your photos with {title} AI effect. Upload and create stunning images instantly.',
        seoVideoKeywords: 'AI video effect, AI video generator, viral video maker, video effect online, free AI video',
        seoPhotoKeywords: 'AI photo effect, AI image generator, photo filter online, image effect maker, free AI photo',
        
        sampleImages: 'Sample Images',
        trySampleImages: 'Try Sample Images',
        selectType: 'Select Type',
        uploadImage: 'Upload Image',
        pleaseUploadImage: 'Please upload an image',
        pleaseCompletePromptVariables: 'Please fill in all prompt variables',
        taskSubmitted: 'Task submitted successfully',
        templateConfigNotFound: 'Template configuration not found',
        
        useThisTemplate: 'Use This Template',
        viewAll: 'View All',
        viewAllVideoEffects: 'View All',
        viewAllPhotoEffects: 'View All',
        
        christmasSpecial: 'Christmas Special',
        tiktokTrend: 'TikTok Trend',
        dance: 'Dance',
        newYear: 'New Year',
        viral: 'Viral',
        art: 'Art',
        interactive: 'Interactive',
        trending: 'Trending',
        portrait: 'Portrait',
        artistic: 'Artistic',
        filter: 'Filter',
    },
    ja: {
        videoEffectsTitle: 'ビデオエフェクト',
        photoEffectsTitle: 'フォトエフェクト',
        aiPhotoEffectsTitle: 'AIフォトエフェクト＆フィルター',
        aiVideoEffectsTitle: 'AIエンタメビデオエフェクト',
        change: '変更',
        selectVideoEffect: 'ビデオエフェクトを1つ選択',
        selectImageEffect: '画像エフェクトを1つ選択',
        
        // SEO 相関
        seoVideoEffectGenerator: 'AI動画エフェクトジェネレーター',
        seoPhotoEffectGenerator: 'AI画像エフェクトジェネレーター',
        seoVideoEffectDesc: 'AIで{title}動画を作成。写真をアップロードして、数秒でバイラル動画を生成。',
        seoPhotoEffectDesc: '{title} AIエフェクトで写真を変換。アップロードして即座に素晴らしい画像を作成。',
        seoVideoKeywords: 'AI動画エフェクト, AI動画ジェネレーター, バイラル動画メーカー, オンライン動画エフェクト, 無料AI動画',
        seoPhotoKeywords: 'AI画像エフェクト, AI画像ジェネレーター, オンライン画像フィルター, 画像エフェクトメーカー, 無料AI画像',
        
        sampleImages: 'サンプル画像',
        trySampleImages: 'サンプル画像を試す',
        selectType: 'タイプを選択',
        uploadImage: '画像をアップロード',
        pleaseUploadImage: '画像をアップロードしてください',
        pleaseCompletePromptVariables: 'すべてのプロンプト変数を入力してください',
        taskSubmitted: 'タスクが正常に送信されました',
        templateConfigNotFound: 'テンプレート設定が見つかりません',
        
        useThisTemplate: 'このテンプレートを使用',
        viewAll: 'すべて表示',
        viewAllVideoEffects: 'すべて表示',
        viewAllPhotoEffects: 'すべて表示',
        
        christmasSpecial: 'クリスマススペシャル',
        tiktokTrend: 'TikTok トレンド',
        dance: 'ダンス',
        newYear: '新年',
        viral: 'バイラル',
        art: 'アート',
        interactive: 'インタラクティブ',
        trending: 'トレンド',
        portrait: 'ポートレート',
        artistic: 'アーティスティック',
        filter: 'フィルター',
    },
    ko: {
        videoEffectsTitle: '비디오 효과',
        photoEffectsTitle: '사진 효과',
        aiPhotoEffectsTitle: 'AI 사진 효과 및 필터',
        aiVideoEffectsTitle: 'AI 재미있는 비디오 효과',
        change: '변경',
        selectVideoEffect: '비디오 효과 하나 선택',
        selectImageEffect: '이미지 효과 하나 선택',
        
        // SEO 관련
        seoVideoEffectGenerator: 'AI 비디오 효과 생성기',
        seoPhotoEffectGenerator: 'AI 사진 효과 생성기',
        seoVideoEffectDesc: 'AI로 {title} 비디오를 만드세요. 사진을 업로드하고 몇 초 만에 바이럴 비디오를 생성하세요.',
        seoPhotoEffectDesc: '{title} AI 효과로 사진을 변환하세요. 업로드하고 즉시 멋진 이미지를 만드세요.',
        seoVideoKeywords: 'AI 비디오 효과, AI 비디오 생성기, 바이럴 비디오 메이커, 온라인 비디오 효과, 무료 AI 비디오',
        seoPhotoKeywords: 'AI 사진 효과, AI 이미지 생성기, 온라인 사진 필터, 이미지 효과 메이커, 무료 AI 사진',
        
        sampleImages: '샘플 이미지',
        trySampleImages: '샘플 이미지 사용하기',
        selectType: '유형 선택',
        uploadImage: '이미지 업로드',
        pleaseUploadImage: '이미지를 업로드해주세요',
        pleaseCompletePromptVariables: '모든 프롬프트 변수를 입력해주세요',
        taskSubmitted: '작업이 성공적으로 제출되었습니다',
        templateConfigNotFound: '템플릿 구성을 찾을 수 없습니다',
        
        useThisTemplate: '이 템플릿 사용',
        viewAll: '모두 보기',
        viewAllVideoEffects: '모두 보기',
        viewAllPhotoEffects: '모두 보기',
        
        christmasSpecial: '크리스마스 스페셜',
        tiktokTrend: 'TikTok 트렌드',
        dance: '댄스',
        newYear: '새해',
        viral: '바이럴',
        art: '아트',
        interactive: '인터랙티브',
        trending: '트렌딩',
        portrait: '초상화',
        artistic: '예술적',
        filter: '필터',
    },
    tw: {
        // 通用
        videoEffectsTitle: '影片特效',
        photoEffectsTitle: '圖片特效',
        aiPhotoEffectsTitle: 'AI 圖片特效與濾鏡',
        aiVideoEffectsTitle: 'AI 娛樂影片特效',
        change: '更換',
        selectVideoEffect: '選擇一個影片特效',
        selectImageEffect: '選擇一個圖片特效',

        // SEO 相關
        seoVideoEffectGenerator: 'AI 影片特效產生器',
        seoPhotoEffectGenerator: 'AI 圖片特效產生器',
        seoVideoEffectDesc:
            '使用 AI 建立 {title} 影片。上傳您的照片，幾秒鐘內生成爆款影片。',
        seoPhotoEffectDesc:
            '使用 {title} AI 特效轉換您的照片。上傳並立即建立令人驚嘆的圖像。',
        seoVideoKeywords:
            'AI 影片特效, AI 影片生成器, 熱門影片製作, 線上影片特效, 免費 AI 影片',
        seoPhotoKeywords:
            'AI 圖片特效, AI 圖片生成器, 線上圖片濾鏡, 圖片特效製作, 免費 AI 圖片',

        // 上傳相關
        sampleImages: '試用範例圖像',
        trySampleImages: '試用範例圖像',
        selectType: '選擇類型',
        uploadImage: '上傳圖片',
        pleaseUploadImage: '請上傳圖片',
        pleaseCompletePromptVariables: '請填寫所有提示詞變量',
        taskSubmitted: '任務提交成功',
        templateConfigNotFound: '模板配置未找到',

        // 類型選擇
        useThisTemplate: '使用此模板',
        viewAll: '查看所有',
        viewAllVideoEffects: '查看全部',
        viewAllPhotoEffects: '查看全部',

        // 分類名稱
        christmasSpecial: '聖誕特惠',
        tiktokTrend: 'TikTok 趨勢',
        dance: '舞蹈',
        newYear: '新年',
        viral: '熱門',
        art: '藝術',
        interactive: '互動',
        trending: '熱門',
        portrait: '肖像',
        artistic: '藝術',
        filter: '濾鏡',
    },
    pl: {
        videoEffectsTitle: 'Efekty wideo',
        photoEffectsTitle: 'Efekty zdjęć',
        aiPhotoEffectsTitle: 'Efekty i filtry zdjęć AI',
        aiVideoEffectsTitle: 'Efekty wideo AI',
        change: 'Zmień',
        selectVideoEffect: 'Wybierz efekt wideo',
        selectImageEffect: 'Wybierz efekt obrazu',

        // SEO
        seoVideoEffectGenerator: 'Generator efektów wideo AI',
        seoPhotoEffectGenerator: 'Generator efektów zdjęć AI',
        seoVideoEffectDesc:
            'Twórz filmy {title} za pomocą AI. Prześlij zdjęcie i generuj viralowe filmy w kilka sekund.',
        seoPhotoEffectDesc:
            'Przekształć zdjęcia za pomocą efektu AI {title}. Prześlij i twórz oszałamiające obrazy natychmiast.',
        seoVideoKeywords:
            'efekty wideo AI, generator wideo AI, viralowe wideo, efekty wideo online, darmowe wideo AI',
        seoPhotoKeywords:
            'efekty zdjęć AI, generator obrazów AI, filtr zdjęć online, efekty zdjęć, darmowe zdjęcia AI',

        sampleImages: 'Przykładowe obrazy',
        trySampleImages: 'Wypróbuj przykłady',
        selectType: 'Wybierz typ',
        uploadImage: 'Prześlij obraz',
        pleaseUploadImage: 'Prześlij obraz',
        pleaseCompletePromptVariables: 'Wypełnij wszystkie zmienne promptu',
        taskSubmitted: 'Zadanie wysłane',
        templateConfigNotFound: 'Nie znaleziono konfiguracji',

        useThisTemplate: 'Użyj tego szablonu',
        viewAll: 'Zobacz wszystko',
        viewAllVideoEffects: 'Zobacz wszystko',
        viewAllPhotoEffects: 'Zobacz wszystko',

        christmasSpecial: 'Świąteczna oferta',
        tiktokTrend: 'Trend TikTok',
        dance: 'Taniec',
        newYear: 'Nowy Rok',
        viral: 'Viralowe',
        art: 'Sztuka',
        interactive: 'Interaktywne',
        trending: 'Na topie',
        portrait: 'Portret',
        artistic: 'Artystyczne',
        filter: 'Filtr',
    },
    es: {
        videoEffectsTitle: 'Efectos de Video',
        photoEffectsTitle: 'Efectos de Foto',
        aiPhotoEffectsTitle: 'Efectos de Foto IA y Filtros',
        aiVideoEffectsTitle: 'Efectos de Video IA Divertidos',
        change: 'Cambiar',
        selectVideoEffect: 'Seleccionar un efecto de video',
        selectImageEffect: 'Seleccionar un efecto de imagen',
        
        // SEO relacionado
        seoVideoEffectGenerator: 'Generador de Efectos de Video IA',
        seoPhotoEffectGenerator: 'Generador de Efectos de Foto IA',
        seoVideoEffectDesc: 'Crea videos de {title} con IA. Sube tu foto y genera videos virales en segundos.',
        seoPhotoEffectDesc: 'Transforma tus fotos con el efecto IA {title}. Sube y crea imágenes impresionantes al instante.',
        seoVideoKeywords: 'efecto de video IA, generador de video IA, creador de videos virales, efecto de video en línea, video IA gratis',
        seoPhotoKeywords: 'efecto de foto IA, generador de imágenes IA, filtro de foto en línea, creador de efectos de imagen, foto IA gratis',
        
        sampleImages: 'Imágenes de Muestra',
        trySampleImages: 'Probar Imágenes de Muestra',
        selectType: 'Seleccionar Tipo',
        uploadImage: 'Subir Imagen',
        pleaseUploadImage: 'Por favor sube una imagen',
        pleaseCompletePromptVariables: 'Completa todas las variables del prompt',
        taskSubmitted: 'Tarea enviada con éxito',
        templateConfigNotFound: 'Configuración de plantilla no encontrada',
        
        useThisTemplate: 'Usar Esta Plantilla',
        viewAll: 'Ver Todo',
        viewAllVideoEffects: 'Ver Todo',
        viewAllPhotoEffects: 'Ver Todo',
        
        christmasSpecial: 'Especial Navideño',
        tiktokTrend: 'Tendencia TikTok',
        dance: 'Baile',
        newYear: 'Año Nuevo',
        viral: 'Viral',
        art: 'Arte',
        interactive: 'Interactivo',
        trending: 'Tendencias',
        portrait: 'Retrato',
        artistic: 'Artístico',
        filter: 'Filtro',
    },
    fr: {
        videoEffectsTitle: 'Effets Vidéo',
        photoEffectsTitle: 'Effets Photo',
        aiPhotoEffectsTitle: 'Effets Photo IA et Filtres',
        aiVideoEffectsTitle: 'Effets Vidéo IA Amusants',
        change: 'Modifier',
        selectVideoEffect: 'Sélectionner un effet vidéo',
        selectImageEffect: 'Sélectionner un effet image',
        
        // SEO associé
        seoVideoEffectGenerator: 'Générateur d\'Effets Vidéo IA',
        seoPhotoEffectGenerator: 'Générateur d\'Effets Photo IA',
        seoVideoEffectDesc: 'Créez des vidéos {title} avec l\'IA. Téléchargez votre photo et générez des vidéos virales en quelques secondes.',
        seoPhotoEffectDesc: 'Transformez vos photos avec l\'effet IA {title}. Téléchargez et créez des images époustouflantes instantanément.',
        seoVideoKeywords: 'effet vidéo IA, générateur vidéo IA, créateur vidéos virales, effet vidéo en ligne, vidéo IA gratuit',
        seoPhotoKeywords: 'effet photo IA, générateur d\'images IA, filtre photo en ligne, créateur d\'effets d\'image, photo IA gratuit',
        
        sampleImages: 'Images Exemples',
        trySampleImages: 'Essayer les Images Exemples',
        selectType: 'Sélectionner le Type',
        uploadImage: 'Télécharger une Image',
        pleaseUploadImage: 'Veuillez télécharger une image',
        pleaseCompletePromptVariables: 'Veuillez remplir toutes les variables du prompt',
        taskSubmitted: 'Tâche soumise avec succès',
        templateConfigNotFound: 'Configuration du modèle non trouvée',
        
        useThisTemplate: 'Utiliser ce Modèle',
        viewAll: 'Voir Tout',
        viewAllVideoEffects: 'Voir Tout',
        viewAllPhotoEffects: 'Voir Tout',
        
        christmasSpecial: 'Spécial Noël',
        tiktokTrend: 'Tendance TikTok',
        dance: 'Danse',
        newYear: 'Nouvel An',
        viral: 'Viral',
        art: 'Art',
        interactive: 'Interactif',
        trending: 'Tendances',
        portrait: 'Portrait',
        artistic: 'Artistique',
        filter: 'Filtre',
    },
    de: {
        videoEffectsTitle: 'Video-Effekte',
        photoEffectsTitle: 'Foto-Effekte',
        aiPhotoEffectsTitle: 'KI-Fotoeffekte und Filter',
        aiVideoEffectsTitle: 'KI-Spaß-Videoeffekte',
        change: 'Ändern',
        selectVideoEffect: 'Einen Videoeffekt auswählen',
        selectImageEffect: 'Einen Bildeffekt auswählen',
        
        // SEO bezogen
        seoVideoEffectGenerator: 'KI-Videoeffekt-Generator',
        seoPhotoEffectGenerator: 'KI-Fotoeffekt-Generator',
        seoVideoEffectDesc: 'Erstellen Sie {title}-Videos mit KI. Laden Sie Ihr Foto hoch und generieren Sie virale Videos in Sekunden.',
        seoPhotoEffectDesc: 'Verwandeln Sie Ihre Fotos mit dem {title} KI-Effekt. Laden Sie hoch und erstellen Sie sofort atemberaubende Bilder.',
        seoVideoKeywords: 'KI-Videoeffekt, KI-Videogenerator, Viral-Video-Maker, Online-Videoeffekt, kostenloses KI-Video',
        seoPhotoKeywords: 'KI-Fotoeffekt, KI-Bildgenerator, Online-Fotofilter, Bildeffekt-Maker, kostenloses KI-Foto',
        
        sampleImages: 'Beispielbilder',
        trySampleImages: 'Beispielbilder ausprobieren',
        selectType: 'Typ auswählen',
        uploadImage: 'Bild hochladen',
        pleaseUploadImage: 'Bitte laden Sie ein Bild hoch',
        pleaseCompletePromptVariables: 'Bitte füllen Sie alle Prompt-Variablen aus',
        taskSubmitted: 'Aufgabe erfolgreich gesendet',
        templateConfigNotFound: 'Vorlagenkonfiguration nicht gefunden',
        
        useThisTemplate: 'Diese Vorlage verwenden',
        viewAll: 'Alle anzeigen',
        viewAllVideoEffects: 'Alle anzeigen',
        viewAllPhotoEffects: 'Alle anzeigen',
        
        christmasSpecial: 'Weihnachts-Special',
        tiktokTrend: 'TikTok-Trend',
        dance: 'Tanz',
        newYear: 'Neujahr',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Im Trend',
        portrait: 'Porträt',
        artistic: 'Künstlerisch',
        filter: 'Filter',
    },
    ru: {
        videoEffectsTitle: 'Видеоэффекты',
        photoEffectsTitle: 'Фотоэффекты',
        aiPhotoEffectsTitle: 'AI Фотоэффекты и Фильтры',
        aiVideoEffectsTitle: 'AI Развлекательные Видеоэффекты',
        change: 'Изменить',
        selectVideoEffect: 'Выберите один видеоэффект',
        selectImageEffect: 'Выберите один эффект изображения',
        
        // SEO связанные
        seoVideoEffectGenerator: 'Генератор видеоэффектов ИИ',
        seoPhotoEffectGenerator: 'Генератор фотоэффектов ИИ',
        seoVideoEffectDesc: 'Создавайте видео {title} с помощью ИИ. Загрузите фото и создайте вирусные видео за секунды.',
        seoPhotoEffectDesc: 'Преобразуйте свои фото с эффектом ИИ {title}. Загрузите и мгновенно создайте потрясающие изображения.',
        seoVideoKeywords: 'видеоэффект ИИ, генератор видео ИИ, создатель вирусных видео, онлайн видеоэффект, бесплатное ИИ видео',
        seoPhotoKeywords: 'фотоэффект ИИ, генератор изображений ИИ, онлайн фотофильтр, создатель эффектов изображений, бесплатное ИИ фото',
        
        sampleImages: 'Примеры изображений',
        trySampleImages: 'Попробовать примеры',
        selectType: 'Выберите тип',
        uploadImage: 'Загрузить изображение',
        pleaseUploadImage: 'Пожалуйста, загрузите изображение',
        pleaseCompletePromptVariables: 'Пожалуйста, заполните все переменные запроса',
        taskSubmitted: 'Задача успешно отправлена',
        templateConfigNotFound: 'Конфигурация шаблона не найдена',
        
        useThisTemplate: 'Использовать этот шаблон',
        viewAll: 'Показать все',
        viewAllVideoEffects: 'Показать все',
        viewAllPhotoEffects: 'Показать все',
        
        christmasSpecial: 'Рождественский спецвыпуск',
        tiktokTrend: 'Тренд TikTok',
        dance: 'Танец',
        newYear: 'Новый год',
        viral: 'Вирусное',
        art: 'Искусство',
        interactive: 'Интерактивный',
        trending: 'В тренде',
        portrait: 'Портрет',
        artistic: 'Художественный',
        filter: 'Фильтр',
    },
    pt: {
        videoEffectsTitle: 'Efeitos de Vídeo',
        photoEffectsTitle: 'Efeitos de Foto',
        aiPhotoEffectsTitle: 'Efeitos de Foto IA e Filtros',
        aiVideoEffectsTitle: 'Efeitos de Vídeo IA Divertidos',
        change: 'Alterar',
        selectVideoEffect: 'Selecionar um efeito de vídeo',
        selectImageEffect: 'Selecionar um efeito de imagem',
        
        // SEO relacionado
        seoVideoEffectGenerator: 'Gerador de Efeitos de Vídeo IA',
        seoPhotoEffectGenerator: 'Gerador de Efeitos de Foto IA',
        seoVideoEffectDesc: 'Crie vídeos {title} com IA. Carregue sua foto e gere vídeos virais em segundos.',
        seoPhotoEffectDesc: 'Transforme suas fotos com o efeito IA {title}. Carregue e crie imagens impressionantes instantaneamente.',
        seoVideoKeywords: 'efeito de vídeo IA, gerador de vídeo IA, criador de vídeos virais, efeito de vídeo online, vídeo IA grátis',
        seoPhotoKeywords: 'efeito de foto IA, gerador de imagens IA, filtro de foto online, criador de efeitos de imagem, foto IA grátis',
        
        sampleImages: 'Imagens de Exemplo',
        trySampleImages: 'Experimentar Imagens de Exemplo',
        selectType: 'Selecionar Tipo',
        uploadImage: 'Carregar Imagem',
        pleaseUploadImage: 'Por favor, carregue uma imagem',
        pleaseCompletePromptVariables: 'Preencha todas as variáveis do prompt',
        taskSubmitted: 'Tarefa enviada com sucesso',
        templateConfigNotFound: 'Configuração do modelo não encontrada',
        
        useThisTemplate: 'Usar Este Modelo',
        viewAll: 'Ver Tudo',
        viewAllVideoEffects: 'Ver Tudo',
        viewAllPhotoEffects: 'Ver Tudo',
        
        christmasSpecial: 'Especial de Natal',
        tiktokTrend: 'Tendência TikTok',
        dance: 'Dança',
        newYear: 'Ano Novo',
        viral: 'Viral',
        art: 'Arte',
        interactive: 'Interativo',
        trending: 'Em Alta',
        portrait: 'Retrato',
        artistic: 'Artístico',
        filter: 'Filtro',
    },
    it: {
        videoEffectsTitle: 'Effetti Video',
        photoEffectsTitle: 'Effetti Foto',
        aiPhotoEffectsTitle: 'Effetti Foto IA e Filtri',
        aiVideoEffectsTitle: 'Effetti Video IA Divertenti',
        change: 'Cambia',
        selectVideoEffect: 'Seleziona un effetto video',
        selectImageEffect: 'Seleziona un effetto immagine',
        
        // SEO correlato
        seoVideoEffectGenerator: 'Generatore di Effetti Video IA',
        seoPhotoEffectGenerator: 'Generatore di Effetti Foto IA',
        seoVideoEffectDesc: 'Crea video {title} con IA. Carica la tua foto e genera video virali in pochi secondi.',
        seoPhotoEffectDesc: 'Trasforma le tue foto con l\'effetto IA {title}. Carica e crea immagini straordinarie istantaneamente.',
        seoVideoKeywords: 'effetto video IA, generatore video IA, creatore video virali, effetto video online, video IA gratis',
        seoPhotoKeywords: 'effetto foto IA, generatore immagini IA, filtro foto online, creatore effetti immagine, foto IA gratis',
        
        sampleImages: 'Immagini di Esempio',
        trySampleImages: 'Prova Immagini di Esempio',
        selectType: 'Seleziona Tipo',
        uploadImage: 'Carica Immagine',
        pleaseUploadImage: 'Per favore carica un\'immagine',
        pleaseCompletePromptVariables: 'Compila tutte le variabili del prompt',
        taskSubmitted: 'Attività inviata con successo',
        templateConfigNotFound: 'Configurazione del modello non trovata',
        
        useThisTemplate: 'Usa Questo Modello',
        viewAll: 'Vedi Tutto',
        viewAllVideoEffects: 'Vedi Tutto',
        viewAllPhotoEffects: 'Vedi Tutto',
        
        christmasSpecial: 'Speciale Natale',
        tiktokTrend: 'Tendenza TikTok',
        dance: 'Ballo',
        newYear: 'Capodanno',
        viral: 'Virale',
        art: 'Arte',
        interactive: 'Interattivo',
        trending: 'Di Tendenza',
        portrait: 'Ritratto',
        artistic: 'Artistico',
        filter: 'Filtro',
    },
    ar: {
        videoEffectsTitle: 'تأثيرات الفيديو',
        photoEffectsTitle: 'تأثيرات الصور',
        aiPhotoEffectsTitle: 'تأثيرات وفلاتر صور الذكاء الاصطناعي',
        aiVideoEffectsTitle: 'تأثيرات فيديو ترفيهية بالذكاء الاصطناعي',
        change: 'تغيير',
        selectVideoEffect: 'اختر تأثير فيديو واحد',
        selectImageEffect: 'اختر تأثير صورة واحد',
        
        // SEO ذات الصلة
        seoVideoEffectGenerator: 'مولد تأثيرات الفيديو بالذكاء الاصطناعي',
        seoPhotoEffectGenerator: 'مولد تأثيرات الصور بالذكاء الاصطناعي',
        seoVideoEffectDesc: 'أنشئ فيديو {title} بالذكاء الاصطناعي. ارفع صورتك وأنشئ فيديوهات فيروسية في ثوانٍ.',
        seoPhotoEffectDesc: 'حوّل صورك بتأثير {title} بالذكاء الاصطناعي. ارفع وأنشئ صورًا مذهلة فورًا.',
        seoVideoKeywords: 'تأثير فيديو ذكاء اصطناعي, مولد فيديو ذكاء اصطناعي, صانع فيديوهات فيروسية, تأثير فيديو أونلاين, فيديو ذكاء اصطناعي مجاني',
        seoPhotoKeywords: 'تأثير صور ذكاء اصطناعي, مولد صور ذكاء اصطناعي, فلتر صور أونلاين, صانع تأثيرات الصور, صور ذكاء اصطناعي مجاني',
        
        sampleImages: 'صور نموذجية',
        trySampleImages: 'جرب الصور النموذجية',
        selectType: 'اختر النوع',
        uploadImage: 'رفع صورة',
        pleaseUploadImage: 'يرجى رفع صورة',
        pleaseCompletePromptVariables: 'يرجى تعبئة جميع متغيرات المطالبة',
        taskSubmitted: 'تم إرسال المهمة بنجاح',
        templateConfigNotFound: 'لم يتم العثور على تكوين القالب',
        
        useThisTemplate: 'استخدم هذا القالب',
        viewAll: 'عرض الكل',
        viewAllVideoEffects: 'عرض الكل',
        viewAllPhotoEffects: 'عرض الكل',
        
        christmasSpecial: 'عرض الكريسماس',
        tiktokTrend: 'ترند تيك توك',
        dance: 'رقص',
        newYear: 'السنة الجديدة',
        viral: 'رائج',
        art: 'فن',
        interactive: 'تفاعلي',
        trending: 'رائج',
        portrait: 'صورة شخصية',
        artistic: 'فني',
        filter: 'فلتر',
        },
    th: {
        videoEffectsTitle: 'เอฟเฟกต์วิดีโอ',
        photoEffectsTitle: 'เอฟเฟกต์ภาพ',
        aiPhotoEffectsTitle: 'เอฟเฟกต์และฟิลเตอร์ภาพ AI',
        aiVideoEffectsTitle: 'เอฟเฟกต์วิดีโอ AI แสนสนุก',
        change: 'เปลี่ยน',
        selectVideoEffect: 'เลือกเอฟเฟกต์วิดีโอ',
        selectImageEffect: 'เลือกเอฟเฟกต์ภาพ',
        
        // SEO 相关
        seoVideoEffectGenerator: 'เครื่องมือสร้างเอฟเฟกต์วิดีโอ AI',
        seoPhotoEffectGenerator: 'เครื่องมือสร้างเอฟเฟกต์ภาพ AI',
        seoVideoEffectDesc: 'สร้างวิดีโอ {title} ด้วย AI อัปโหลดรูปภาพและสร้างวิดีโอไวรัลในไม่กี่วินาที',
        seoPhotoEffectDesc: 'แปลงโฉมรูปภาพของคุณด้วยเอฟเฟกต์ AI {title} อัปโหลดและสร้างภาพที่น่าทึ่งทันที',
        seoVideoKeywords: 'เอฟเฟกต์วิดีโอ AI, เครื่องมือสร้างวิดีโอ AI, ทำวิดีโอไวรัล, เอฟเฟกต์วิดีโอออนไลน์, วิดีโอ AI ฟรี',
        seoPhotoKeywords: 'เอฟเฟกต์ภาพถ่าย AI, เครื่องมือสร้างภาพ AI, ฟิลเตอร์ภาพออนไลน์, ทำเอฟเฟกต์ภาพ, ภาพ AI ฟรี',
        
        sampleImages: 'รูปภาพตัวอย่าง',
        trySampleImages: 'ลองใช้รูปภาพตัวอย่าง',
        selectType: 'เลือกประเภท',
        uploadImage: 'อัปโหลดรูปภาพ',
        pleaseUploadImage: 'กรุณาอัปโหลดรูปภาพ',
        pleaseCompletePromptVariables: 'กรุณากรอกตัวแปรพรอมต์ให้ครบ',
        taskSubmitted: 'ส่งงานสำเร็จแล้ว',
        templateConfigNotFound: 'ไม่พบการตั้งค่าเทมเพลต',
        
        useThisTemplate: 'ใช้เทมเพลตนี้',
        viewAll: 'ดูทั้งหมด',
        viewAllVideoEffects: 'ดูทั้งหมด',
        viewAllPhotoEffects: 'ดูทั้งหมด',
        
        christmasSpecial: 'สเปเชียลคริสต์มาส',
        tiktokTrend: 'เทรนด์ TikTok',
        dance: 'เต้น',
        newYear: 'ปีใหม่',
        viral: 'ไวรัล',
        art: 'ศิลปะ',
        interactive: 'อินเทอร์แอคทีฟ',
        trending: 'มาแรง',
        portrait: 'พอร์ตเทรต',
        artistic: 'เชิงศิลป์',
        filter: 'ฟิลเตอร์',
        },
    da: {
        videoEffectsTitle: 'Videoeffekter',
        photoEffectsTitle: 'Billedeffekter',
        aiPhotoEffectsTitle: 'AI billed-effekter & filtre',
        aiVideoEffectsTitle: 'AI sjove videoeffekter',
        change: 'Skift',
        selectVideoEffect: 'Vælg en videoeffekt',
        selectImageEffect: 'Vælg en billedeffekt',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI videoeffekt generator',
        seoPhotoEffectGenerator: 'AI billedeffekt generator',
        seoVideoEffectDesc: 'Opret {title} video med AI. Upload dit foto og generer virale videoer på få sekunder.',
        seoPhotoEffectDesc: 'Forvandl dine fotos med {title} AI-effekt. Upload og skab fantastiske billeder øjeblikkeligt.',
        seoVideoKeywords: 'AI videoeffekt, AI videogenerator, viral video maker, videoeffekt online, gratis AI video',
        seoPhotoKeywords: 'AI billedeffekt, AI billedgenerator, fotofilter online, billedeffekt‑maker, gratis AI foto',
        
        sampleImages: 'Eksempelbilleder',
        trySampleImages: 'Prøv eksempelbilleder',
        selectType: 'Vælg type',
        uploadImage: 'Upload billede',
        pleaseUploadImage: 'Upload venligst et billede',
        pleaseCompletePromptVariables: 'Udfyld alle promptvariabler',
        taskSubmitted: 'Opgave indsendt',
        templateConfigNotFound: 'Skabelonkonfiguration ikke fundet',
        
        useThisTemplate: 'Brug denne skabelon',
        viewAll: 'Se alle',
        viewAllVideoEffects: 'Se alle',
        viewAllPhotoEffects: 'Se alle',
        
        christmasSpecial: 'Julespecial',
        tiktokTrend: 'TikTok‑trend',
        dance: 'Dans',
        newYear: 'Nytår',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Trending',
        portrait: 'Portræt',
        artistic: 'Kunstnerisk',
        filter: 'Filter',
        },
    no: {
        videoEffectsTitle: 'Videoeffekter',
        photoEffectsTitle: 'Bildeeffekter',
        aiPhotoEffectsTitle: 'AI bildeeffekter og filtre',
        aiVideoEffectsTitle: 'AI morsomme videoeffekter',
        change: 'Endre',
        selectVideoEffect: 'Velg en videoeffekt',
        selectImageEffect: 'Velg en bildeeffekt',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI videoeffektgenerator',
        seoPhotoEffectGenerator: 'AI bildeeffektgenerator',
        seoVideoEffectDesc: 'Lag {title}-video med AI. Last opp bildet ditt og generer virale videoer på sekunder.',
        seoPhotoEffectDesc: 'Forvandle bildene dine med {title} AI-effekt. Last opp og lag fantastiske bilder umiddelbart.',
        seoVideoKeywords: 'AI videoeffekt, AI videogernerator, viral videomaker, videoeffekt online, gratis AI video',
        seoPhotoKeywords: 'AI bildeeffekt, AI bildegenerator, fotofilter online, bildeeffekt‑maker, gratis AI foto',
        
        sampleImages: 'Eksempelbilder',
        trySampleImages: 'Prøv eksempelbilder',
        selectType: 'Velg type',
        uploadImage: 'Last opp bilde',
        pleaseUploadImage: 'Vennligst last opp et bilde',
        pleaseCompletePromptVariables: 'Fyll ut alle promptvariabler',
        taskSubmitted: 'Oppgave sendt',
        templateConfigNotFound: 'Malkonfigurasjon ikke funnet',
        
        useThisTemplate: 'Bruk denne malen',
        viewAll: 'Se alle',
        viewAllVideoEffects: 'Se alle',
        viewAllPhotoEffects: 'Se alle',
        
        christmasSpecial: 'Julespesial',
        tiktokTrend: 'TikTok‑trend',
        dance: 'Dans',
        newYear: 'Nyttår',
        viral: 'Viral',
        art: 'Kunst',
        interactive: 'Interaktiv',
        trending: 'Trending',
        portrait: 'Portrett',
        artistic: 'Kunstnerisk',
        filter: 'Filter',
        },
    nl: {
        videoEffectsTitle: 'Video-effecten',
        photoEffectsTitle: 'Beeld-effecten',
        aiPhotoEffectsTitle: 'AI beeld-effecten & filters',
        aiVideoEffectsTitle: 'AI leuke video-effecten',
        change: 'Wijzigen',
        selectVideoEffect: 'Selecteer een video-effect',
        selectImageEffect: 'Selecteer een beeld-effect',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI video-effect generator',
        seoPhotoEffectGenerator: 'AI beeld-effect generator',
        seoVideoEffectDesc: 'Maak {title} video met AI. Upload je foto en genereer virale videos in seconden.',
        seoPhotoEffectDesc: 'Transformeer je fotos met {title} AI-effect. Upload en maak direct prachtige beelden.',
        seoVideoKeywords: 'AI video‑effect, AI videogenarator, viral video maker, video‑effect online, gratis AI video',
        seoPhotoKeywords: 'AI foto‑effect, AI beeldgenerator, fotofilter online, beeld‑effect maker, gratis AI foto',
        
        sampleImages: 'Voorbeeldafbeeldingen',
        trySampleImages: 'Probeer voorbeelden',
        selectType: 'Selecteer type',
        uploadImage: 'Afbeelding uploaden',
        pleaseUploadImage: 'Upload een afbeelding',
        pleaseCompletePromptVariables: 'Vul alle promptvariabelen in',
        taskSubmitted: 'Taak ingediend',
        templateConfigNotFound: 'Sjabloonconfiguratie niet gevonden',
        
        useThisTemplate: 'Gebruik dit sjabloon',
        viewAll: 'Bekijk alles',
        viewAllVideoEffects: 'Bekijk alles',
        viewAllPhotoEffects: 'Bekijk alles',
        
        christmasSpecial: 'Kerstspecial',
        tiktokTrend: 'TikTok‑trend',
        dance: 'Dans',
        newYear: 'Nieuwjaar',
        viral: 'Viraal',
        art: 'Kunst',
        interactive: 'Interactief',
        trending: 'Trending',
        portrait: 'Portret',
        artistic: 'Artistiek',
        filter: 'Filter',
        },
    id: {
        videoEffectsTitle: 'Efek Video',
        photoEffectsTitle: 'Efek Gambar',
        aiPhotoEffectsTitle: 'Efek & Filter Gambar AI',
        aiVideoEffectsTitle: 'Efek Video Menyenangkan AI',
        change: 'Ubah',
        selectVideoEffect: 'Pilih efek video',
        selectImageEffect: 'Pilih efek gambar',
        
        // SEO 相关
        seoVideoEffectGenerator: 'Generator Efek Video AI',
        seoPhotoEffectGenerator: 'Generator Efek Gambar AI',
        seoVideoEffectDesc: 'Buat video {title} dengan AI. Unggah foto Anda dan hasilkan video viral dalam hitungan detik.',
        seoPhotoEffectDesc: 'Transformasikan foto Anda dengan efek AI {title}. Unggah dan buat gambar menakjubkan secara instan.',
        seoVideoKeywords: 'efek video AI, generator video AI, pembuat video viral, efek video online, video AI gratis',
        seoPhotoKeywords: 'efek foto AI, generator gambar AI, filter foto online, pembuat efek gambar, foto AI gratis',
        
        sampleImages: 'Gambar Contoh',
        trySampleImages: 'Coba Gambar Contoh',
        selectType: 'Pilih Tipe',
        uploadImage: 'Unggah Gambar',
        pleaseUploadImage: 'Silakan unggah gambar',
        pleaseCompletePromptVariables: 'Isi semua variabel prompt',
        taskSubmitted: 'Tugas berhasil dikirim',
        templateConfigNotFound: 'Konfigurasi templat tidak ditemukan',
        
        useThisTemplate: 'Gunakan Templat Ini',
        viewAll: 'Lihat Semua',
        viewAllVideoEffects: 'Lihat Semua',
        viewAllPhotoEffects: 'Lihat Semua',
        
        christmasSpecial: 'Spesial Natal',
        tiktokTrend: 'Tren TikTok',
        dance: 'Tarian',
        newYear: 'Tahun Baru',
        viral: 'Viral',
        art: 'Seni',
        interactive: 'Interaktif',
        trending: 'Trending',
        portrait: 'Potret',
        artistic: 'Artistik',
        filter: 'Filter',
        },
    tr: {
        videoEffectsTitle: 'Video Efektleri',
        photoEffectsTitle: 'Fotoğraf Efektleri',
        aiPhotoEffectsTitle: 'AI Fotoğraf Efektleri ve Filtreleri',
        aiVideoEffectsTitle: 'AI Eğlenceli Video Efektleri',
        change: 'Değiştir',
        selectVideoEffect: 'Bir video efekti seçin',
        selectImageEffect: 'Bir görsel efekti seçin',
        
        // SEO 相关
        seoVideoEffectGenerator: 'AI Video Efekt Oluşturucu',
        seoPhotoEffectGenerator: 'AI Fotoğraf Efekt Oluşturucu',
        seoVideoEffectDesc: 'AI ile {title} videosu oluşturun. Fotoğrafınızı yükleyin ve saniyeler içinde viral videolar oluşturun.',
        seoPhotoEffectDesc: '{title} AI efekti ile fotoğraflarınızı dönüştürün. Yükleyin ve anında harika görseller oluşturun.',
        seoVideoKeywords: 'AI video efekti, AI video oluşturucu, viral video yapıcı, online video efekti, ücretsiz AI video',
        seoPhotoKeywords: 'AI fotoğraf efekti, AI görsel oluşturucu, online fotoğraf filtresi, görsel efekt yapıcı, ücretsiz AI foto',
        
        sampleImages: 'Örnek Görseller',
        trySampleImages: 'Örnek Görselleri Deneyin',
        selectType: 'Tür Seçin',
        uploadImage: 'Görsel Yükle',
        pleaseUploadImage: 'Lütfen bir görsel yükleyin',
        pleaseCompletePromptVariables: 'Lütfen tüm prompt değişkenlerini doldurun',
        taskSubmitted: 'Görev başarıyla gönderildi',
        templateConfigNotFound: 'Şablon yapılandırması bulunamadı',
        
        useThisTemplate: 'Bu Şablonu Kullan',
        viewAll: 'Tümünü Gör',
        viewAllVideoEffects: 'Tümünü Gör',
        viewAllPhotoEffects: 'Tümünü Gör',
        
        christmasSpecial: 'Noel özel',
        tiktokTrend: 'TikTok trendi',
        dance: 'Dans',
        newYear: 'Yeni Yıl',
        viral: 'Viral',
        art: 'Sanat',
        interactive: 'Etkileşimli',
        trending: 'Trend',
        portrait: 'Portre',
        artistic: 'Sanatsal',
        filter: 'Filtre',
    },
}
